/**
 * Coach/client workout save: integer-like reps → number; rep ranges (e.g. "8-12") → string.
 */
export function normalizeRepsForPayload(raw) {
  if (raw === null || raw === undefined || raw === "") return null;
  if (typeof raw === "number" && Number.isFinite(raw)) {
    return Number.isInteger(raw) ? raw : Math.round(raw);
  }
  const t = String(raw).trim();
  if (t === "") return null;
  if (/^-?\d+$/.test(t)) return parseInt(t, 10);
  return t;
}
